<div>
    <app-icon ic="IcTrash" size="s" color="var(--color-primary-60)" (click)="deleteBtnAction()"></app-icon>
</div>
